import { SelectBox } from "devextreme-react";
import { useAppDispatch } from "@hooks/useAppDispatch";
import { useAppSelector } from "@hooks/useAppSelector";
import { npvActions } from "@redux/npv/npv-slice";
import { CalcGrid, Recalculate } from "@redux/npv/npv-actions";

export default function IRR() {
  const dispatch = useAppDispatch();
  const settings = useAppSelector((state) => state.npv.settings);
  const { gridSet } = useAppSelector((state) => state.uq);

  function irrDisplay(value: number) {
    return String(value * 100) + "%";
  }

  return (
    <div className="print:pt-4">
      <SelectBox
        onValueChange={(e) => {
          dispatch(
            npvActions.setSettings({
              ...settings,
              irr: e,
            })
          );
          dispatch(Recalculate());
          dispatch(CalcGrid(gridSet));
          dispatch(npvActions.setIsModified(true));
        }}
        width={162}
        label="Internal Rate of Return"
        stylingMode="outlined"
        items={[0.05, 0.06]}
        value={settings?.irr}
        displayExpr={irrDisplay}
      />
    </div>
  );
}
